import { apiClient } from './api-client'

export type RunStatus = 'EM_ANDAMENTO' | 'CONCLUIDA' | 'CONCLUIDA_COM_ERROS' | 'FALHOU'

export interface ImportRunItem {
  id: string
  monitoramentoId: string | null
  alvo: string
  status: 'EM_ANDAMENTO' | 'OK' | 'ERRO'
  tentativas: number
  novas: number
  repetidas: number
  erro: string | null
  iniciadoEm: string
  finalizadoEm: string | null
}

export interface ImportRun {
  id: string
  origem: 'AGENDADA' | 'MANUAL'
  escopo: 'TODOS' | 'MONITORAMENTO'
  dataInicio: string | null
  dataFim: string | null
  status: RunStatus
  novas: number
  repetidas: number
  erros: number
  iniciadoPorNome: string | null
  iniciadoEm: string
  finalizadoEm: string | null
  itens?: ImportRunItem[]
}

export interface Monitor {
  id: string
  tipo: 'OAB' | 'PROCESSO'
  status: 'ATIVO' | 'PAUSADO'
  ownerUserId: string | null
  ownerName: string | null
  label: string
  numeroProcesso: string | null
  falhasConsecutivas: number
  ultimaExecucaoEm: string | null
  ultimoErro: string | null
  createdBy: string | null
}

export interface StartRunInput {
  escopo: 'TODOS' | 'MONITORAMENTO'
  monitoramentoId?: string
  dataInicio?: string
  dataFim?: string
}

/** Importações do DJEN (execuções) e monitoramentos (OABs e processos). */
export const importacoesService = {
  async listRuns(limit = 30): Promise<ImportRun[]> {
    const response = await apiClient.get('/api/djen/runs', { params: { limit } })
    return response.data.data
  },

  async getRun(id: string): Promise<ImportRun> {
    const response = await apiClient.get(`/api/djen/runs/${id}`)
    return response.data.data
  },

  async startRun(input: StartRunInput): Promise<{ runId: string }> {
    const response = await apiClient.post('/api/djen/runs', input)
    return response.data.data
  },

  async listMonitors(): Promise<Monitor[]> {
    const response = await apiClient.get('/api/djen/monitoramentos')
    return response.data.data
  },

  async addProcess(numeroProcesso: string): Promise<Monitor> {
    const response = await apiClient.post('/api/djen/monitoramentos/processos', { numeroProcesso })
    return response.data.data
  },

  async setMonitorStatus(id: string, status: 'ATIVO' | 'PAUSADO'): Promise<Monitor> {
    const response = await apiClient.patch(`/api/djen/monitoramentos/${id}`, { status })
    return response.data.data
  },
}
